import { LILAC_400, isValidObject, tokens } from '@airtel/air-design-system';
import { StyleSheet } from 'react-native';
import { checkForPrice } from './AddOnWidgetUtils';
export var getAddOnWidgetStyles = (props, isLargeScreen) => {
  var tertiaryCtaData = props.tertiaryCtaData,
    isPriceInRow = props.isPriceInRow;
  var spacing = tokens.spacing;
  var border = tokens.borderRadius;
  var showPriceSection = checkForPrice(props);
  return StyleSheet.create({
    wrapper: {
      flex: 1,
      flexDirection: 'row'
    },
    imagesection: {
      height: isLargeScreen ? spacing.SPACING_72 : spacing.SPACING_56,
      width: isLargeScreen ? spacing.SPACING_72 : spacing.SPACING_56,
      marginRight: spacing.SPACING_8
    },
    logoImage: {
      borderRadius: border === null || border === void 0 ? void 0 : border.BORDER_RADIUS_8,
      height: '100%',
      width: '100%'
    },
    ottSection: {
      width: isLargeScreen && spacing.SPACING_72,
      marginRight: spacing.SPACING_8,
      marginLeft: isLargeScreen ? spacing.SPACING_80 : spacing.SPACING_64
    },
    ottImage: {
      height: spacing.SPACING_32,
      width: spacing.SPACING_32,
      borderRadius: border === null || border === void 0 ? void 0 : border.BORDER_RADIUS_8
    },
    middleSection: {
      flex: 1
    },
    textLabels: {
      flexDirection: 'row',
      flexWrap: 'nowrap',
      marginBottom: spacing.SPACING_4
    },
    infotag: {
      marginRight: spacing.SPACING_4
    },
    buttonWidgetWrapper: {
      backgroundColor: LILAC_400,
      paddingHorizontal: spacing.SPACING_12,
      borderRadius: border === null || border === void 0 ? void 0 : border.BORDER_RADIUS_10,
      justifyContent: 'center'
    },
    description: {
      marginTop: spacing.SPACING_4
    },
    tertiaryButtonWidget: {
      marginTop: isValidObject(tertiaryCtaData === null || tertiaryCtaData === void 0 ? void 0 : tertiaryCtaData.leftCta) || showPriceSection ? isValidObject(tertiaryCtaData === null || tertiaryCtaData === void 0 ? void 0 : tertiaryCtaData.leftCta) ? spacing.SPACING_12 : spacing.SPACING_16 : spacing.SPACING_0
    },
    rightSection: {
      flexDirection: 'column',
      justifyContent: 'space-between'
    },
    cardType: {
      alignSelf: 'flex-end',
      opacity: props.type === 'none' ? 0 : 1,
      flexDirection: 'row'
    },
    secondaryRightTag: {
      marginRight: spacing.SPACING_4
    },
    infoIcon: {
      marginLeft: spacing.SPACING_4
    },
    titleContainer: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      zIndex: 999,
      justifyContent: isPriceInRow ? 'space-between' : 'flex-start'
    },
    checkBoxAndRadioArea: {
      paddingBottom: spacing.SPACING_24
    }
  });
};